import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";
import { Medication } from "src/api/types";
import { useManageDrawer } from "src/hooks/useManageDrawer";
import UpdateMedicationDrawer from "./components/UpdateMedicationDrawer";

type ContextType = {
  updateActions: {
    handleOpen: () => void;
    handleClose: () => void;
  };
  medication: Medication | null;
  handleOpenUpdateMedication: (medication: Medication | null) => void;
};

export const MedicationsDrawerContext = createContext<ContextType>({
  updateActions: {
    handleClose: () => {},
    handleOpen: () => {},
  },
  medication: null,
  handleOpenUpdateMedication: () => {},
});

interface Props {
  children: ReactNode;
}

const MedicationsDrawerProvider = ({ children }: Props) => {
  const [openUpdate, updateActions] = useManageDrawer();
  const [medication, setMedication] = useState<Medication | null>(null);

  const handleOpenUpdateMedication = useCallback(
    (medication: Medication | null) => {
      setMedication(medication);
      updateActions.handleOpen();
    },
    [updateActions],
  );

  const value = useMemo(
    () => ({
      updateActions,
      medication,
      handleOpenUpdateMedication,
    }),
    [handleOpenUpdateMedication, medication, updateActions],
  );

  return (
    <MedicationsDrawerContext.Provider value={value}>
      {children}
      {medication ? (
        <UpdateMedicationDrawer
          onClose={updateActions.handleClose}
          open={openUpdate}
          medication={medication}
        />
      ) : null}
    </MedicationsDrawerContext.Provider>
  );
};

export default MedicationsDrawerProvider;
